import { render, staticRenderFns } from "./associazioneNazionalita.vue?vue&type=template&id=5aa25c90&"
import script from "./associazioneNazionalita.vue.ts?vue&type=script&lang=ts&"
export * from "./associazioneNazionalita.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports